import {FC, PropsWithChildren} from "react";
import styled from "styled-components";

const Wrapper = styled.div`
	max-width: 1240px;
	width: 100%;
	margin: 0 auto;
	text-align: left;

	@media (min-width: 769px) {
		padding: 20px;
	}
`;

export const PageLayout: FC<PropsWithChildren<unknown>> = ({children}) => {
	return <Wrapper>{children}</Wrapper>;
};
